<template>
  <div>
    <div v-if="temWhiteLabel === null" class="text-center py-5">
      <b-spinner variant="primary" style="width:3rem;height:3rem;" />
      <p class="mt-2 text-muted">Verificando assinatura...</p>
    </div>

    <b-card v-else-if="temWhiteLabel === false" class="text-center py-4">
      <feather-icon icon="LockIcon" size="56" class="text-warning mb-2" />
      <h3>Recurso exclusivo para assinantes</h3>
      <p class="text-muted mb-2">
        A funcionalidade <strong>WhiteLabel</strong> (Minha Loja personalizada) requer um plano ativo.<br>
        Entre em contato com o suporte ou administrador para assinar um plano com WhiteLabel.
      </p>
      <div v-if="planos.length" class="mt-2">
        <p class="font-weight-bold">Planos com WhiteLabel disponíveis:</p>
        <b-row class="justify-content-center">
          <b-col v-for="p in planos" :key="p.id" cols="12" sm="6" md="4" class="mb-1">
            <b-card border-variant="primary" class="text-left">
              <h5 class="text-primary">{{ p.nome }}</h5>
              <p class="small text-muted mb-1">{{ p.descricao }}</p>
              <div class="font-weight-bold">R$ {{ Number(p.preco_mensal).toFixed(2).replace('.', ',') }}<small class="text-muted">/mês</small></div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <template v-else>
    <b-alert v-if="statusMessage" :variant="statusVariant" show dismissible @dismissed="statusMessage = ''">
      {{ statusMessage }}
    </b-alert>

    <b-card v-if="loja.slug" class="mb-2">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <small class="text-muted">Link da sua loja:</small>
          <h5 class="mb-0">
            <feather-icon icon="ExternalLinkIcon" size="16" class="mr-1" />
            /loja/{{ loja.slug }}
          </h5>
        </div>
        <b-button variant="outline-primary" size="sm" @click="copyLink">
          <feather-icon icon="CopyIcon" size="14" class="mr-50" />
          Copiar Link
        </b-button>
      </div>
    </b-card>

    <b-card>
      <b-card-title class="d-flex align-items-center mb-2">
        <feather-icon icon="ShoppingBagIcon" size="24" class="mr-1" />
        Minha Loja WhiteLabel
      </b-card-title>

      <b-tabs pills>
        <b-tab title="Configurações" active>
          <b-form class="mt-2" @submit.prevent="salvar">
            <b-row>
              <b-col md="6">
                <b-form-group label="Nome da Loja" label-for="nome_loja">
                  <b-form-input id="nome_loja" v-model="form.nome_loja" placeholder="Nome da sua loja" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Slug (URL)" label-for="slug">
                  <b-input-group>
                    <b-input-group-prepend is-text>/loja/</b-input-group-prepend>
                    <b-form-input id="slug" v-model="form.slug" placeholder="minha-loja" @input="onSlugInput" />
                    <b-input-group-append is-text>
                      <feather-icon v-if="slugStatus === 'available'" icon="CheckCircleIcon" class="text-success" />
                      <feather-icon v-else-if="slugStatus === 'taken'" icon="XCircleIcon" class="text-danger" />
                      <b-spinner v-else-if="slugStatus === 'checking'" small />
                    </b-input-group-append>
                  </b-input-group>
                  <small v-if="slugStatus === 'taken'" class="text-danger">Este slug já está em uso.</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Descrição" label-for="descricao">
                  <b-form-textarea id="descricao" v-model="form.descricao" rows="3" placeholder="Descrição da sua loja" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group label="WhatsApp" label-for="whatsapp">
                  <b-form-input id="whatsapp" v-model="form.whatsapp" placeholder="(11) 99999-9999" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Instagram" label-for="instagram">
                  <b-form-input id="instagram" v-model="form.instagram" placeholder="@sualoja" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Facebook" label-for="facebook">
                  <b-form-input id="facebook" v-model="form.facebook" placeholder="facebook.com/sualoja" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="primary" :disabled="saving || slugStatus === 'taken'">
              <b-spinner v-if="saving" small class="mr-50" />
              Salvar Configurações
            </b-button>
          </b-form>
        </b-tab>

        <b-tab title="Aparência">
          <b-form class="mt-2" @submit.prevent="salvar">
            <b-row>
              <b-col md="6">
                <b-form-group label="Logo (Header)">
                  <div class="d-flex align-items-center mb-1">
                    <b-form-file
                      accept="image/*"
                      placeholder="Enviar imagem..."
                      browse-text="Escolher"
                      @input="uploadImage($event, 'logo_header')"
                      :disabled="uploading.logo_header"
                      size="sm"
                    />
                    <b-spinner v-if="uploading.logo_header" small class="ml-1" />
                  </div>
                  <b-form-input v-model="form.logo_header" placeholder="ou cole a URL da imagem" size="sm" />
                  <div v-if="form.logo_header" class="mt-1">
                    <img :src="form.logo_header" alt="Logo Header" style="max-height: 60px; max-width: 200px;" class="border rounded p-1" />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Logo (Footer)">
                  <div class="d-flex align-items-center mb-1">
                    <b-form-file
                      accept="image/*"
                      placeholder="Enviar imagem..."
                      browse-text="Escolher"
                      @input="uploadImage($event, 'logo_footer')"
                      :disabled="uploading.logo_footer"
                      size="sm"
                    />
                    <b-spinner v-if="uploading.logo_footer" small class="ml-1" />
                  </div>
                  <b-form-input v-model="form.logo_footer" placeholder="ou cole a URL da imagem" size="sm" />
                  <div v-if="form.logo_footer" class="mt-1">
                    <img :src="form.logo_footer" alt="Logo Footer" style="max-height: 60px; max-width: 200px;" class="border rounded p-1" />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group label-for="cor_principal">
                  <template #label>
                    Cor Principal
                    <small class="text-muted d-block">Botões, chat, CTAs e destaques</small>
                  </template>
                  <div class="d-flex align-items-center">
                    <input type="color" id="cor_principal" v-model="form.cor_principal" class="mr-1" style="width: 40px; height: 40px; border: none; cursor: pointer;" />
                    <b-form-input v-model="form.cor_principal" style="max-width: 120px;" />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="cor_secundaria">
                  <template #label>
                    Cor Secundária
                    <small class="text-muted d-block">Navbar, footer e elementos estruturais</small>
                  </template>
                  <div class="d-flex align-items-center">
                    <input type="color" id="cor_secundaria" v-model="form.cor_secundaria" class="mr-1" style="width: 40px; height: 40px; border: none; cursor: pointer;" />
                    <b-form-input v-model="form.cor_secundaria" style="max-width: 120px;" />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Cor de Fundo" label-for="bg_fundo">
                  <div class="d-flex align-items-center">
                    <input type="color" id="bg_fundo" v-model="form.bg_fundo" class="mr-1" style="width: 40px; height: 40px; border: none; cursor: pointer;" />
                    <b-form-input v-model="form.bg_fundo" style="max-width: 120px;" />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Favicon">
                  <div class="d-flex align-items-center mb-1">
                    <b-form-file
                      accept="image/*"
                      placeholder="Enviar imagem..."
                      browse-text="Escolher"
                      @input="uploadImage($event, 'favicon')"
                      :disabled="uploading.favicon"
                      size="sm"
                    />
                    <b-spinner v-if="uploading.favicon" small class="ml-1" />
                  </div>
                  <b-form-input v-model="form.favicon" placeholder="ou cole a URL do favicon" size="sm" />
                  <div v-if="form.favicon" class="mt-1">
                    <img :src="form.favicon" alt="Favicon" style="max-height: 32px; max-width: 32px;" class="border rounded p-1" />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="mt-2 p-3 border rounded" :style="{ backgroundColor: form.bg_fundo }">
              <h6 class="mb-2">Pré-visualização</h6>
              <div class="d-flex align-items-stretch mb-2" style="border-radius: 8px; overflow: hidden; height: 40px;">
                <div class="d-flex align-items-center px-3 text-white" :style="{ backgroundColor: form.cor_secundaria, flex: 1 }">
                  <small class="font-weight-bold">Navbar / Footer</small>
                </div>
                <div class="d-flex align-items-center px-3 text-white" :style="{ backgroundColor: form.cor_principal, flex: 1 }">
                  <small class="font-weight-bold">Botões / Ações</small>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="px-3 py-1 rounded text-white mr-2" :style="{ backgroundColor: form.cor_principal, fontSize: '12px' }">Comprar</div>
                <div class="px-3 py-1 rounded text-white mr-2" :style="{ backgroundColor: form.cor_principal, fontSize: '12px' }">Adicionar</div>
                <div class="rounded-circle d-flex align-items-center justify-content-center text-white" :style="{ backgroundColor: form.cor_principal, width: '32px', height: '32px', fontSize: '14px' }">
                  <feather-icon icon="MessageCircleIcon" size="16" />
                </div>
              </div>
            </div>

            <b-button type="submit" variant="primary" class="mt-2" :disabled="saving">
              <b-spinner v-if="saving" small class="mr-50" />
              Salvar Aparência
            </b-button>
          </b-form>
        </b-tab>

        <b-tab title="SEO">
          <b-form class="mt-2" @submit.prevent="salvar">
            <b-row>
              <b-col md="12">
                <b-form-group label="Título da Página (Meta Title)" label-for="meta_title">
                  <b-form-input id="meta_title" v-model="form.meta_title" placeholder="Título para SEO" />
                  <small class="text-muted">{{ (form.meta_title || '').length }}/60 caracteres recomendados</small>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Descrição (Meta Description)" label-for="meta_description">
                  <b-form-textarea id="meta_description" v-model="form.meta_description" rows="3" placeholder="Descrição para SEO" />
                  <small class="text-muted">{{ (form.meta_description || '').length }}/160 caracteres recomendados</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="primary" :disabled="saving">
              <b-spinner v-if="saving" small class="mr-50" />
              Salvar SEO
            </b-button>
          </b-form>
        </b-tab>

        <b-tab title="Rodapé / Identidade">
          <b-form class="mt-2" @submit.prevent="salvar">
            <b-alert variant="info" show class="mb-3">
              <small>Personalize o rodapé da sua loja. Quando os campos estão vazios, o sistema usa o nome da loja automaticamente. Para um WhiteLabel completo, preencha todos os campos e desmarque o "Powered by".</small>
            </b-alert>
            <b-row>
              <b-col md="6">
                <b-form-group label="Nome da Empresa" label-for="empresa_nome">
                  <b-form-input id="empresa_nome" v-model="form.empresa_nome" placeholder="Razão social ou nome fantasia" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Texto de Copyright" label-for="texto_copyright">
                  <b-form-input id="texto_copyright" v-model="form.texto_copyright" placeholder="Ex: © 2026 Minha Loja. Todos os direitos reservados." />
                  <small class="text-muted">Se vazio, usa o nome da loja automaticamente</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Informações da Empresa" label-for="empresa_info">
                  <b-form-textarea id="empresa_info" v-model="form.empresa_info" rows="3" placeholder="CNPJ, endereço, etc. (cada linha aparece separada)" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="E-mail de Contato" label-for="email_contato">
                  <b-form-input id="email_contato" v-model="form.email_contato" type="email" placeholder="contato@sualoja.com" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Telefone de Contato" label-for="telefone_contato">
                  <b-form-input id="telefone_contato" v-model="form.telefone_contato" placeholder="(11) 3456-7890" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Texto Sobre (Rodapé)" label-for="texto_sobre">
                  <b-form-textarea id="texto_sobre" v-model="form.texto_sobre" rows="3" placeholder="Texto descritivo que aparece no rodapé da loja" />
                  <small class="text-muted">Se vazio, usa a descrição da loja</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-form-checkbox v-model="form.mostrar_powered_by" :value="1" :unchecked-value="0">
                    Exibir "Powered by AV Market" na loja
                  </b-form-checkbox>
                  <small class="text-muted">Desmarque para remover qualquer referência ao AV Market</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="primary" :disabled="saving">
              <b-spinner v-if="saving" small class="mr-50" />
              Salvar Rodapé
            </b-button>
          </b-form>
        </b-tab>

        <b-tab title="Google Manager">
          <b-form class="mt-2" @submit.prevent="salvar">
            <b-alert variant="info" show class="mb-3">
              <small>Cole o ID do Google Tag Manager ou o script completo. O sistema salva apenas o ID no formato GTM-XXXXXXX.</small>
            </b-alert>
            <b-row>
              <b-col md="12">
                <b-form-group label="Google Tag Manager" label-for="google_tag_manager_id">
                  <b-form-textarea
                    id="google_tag_manager_id"
                    v-model="form.google_tag_manager_id"
                    rows="5"
                    placeholder="Ex: GTM-NTNF95Z6 ou cole o script completo do Google Tag Manager"
                    @blur="normalizeGoogleTagManagerId"
                  />
                  <small v-if="form.google_tag_manager_id" class="text-muted">
                    ID salvo: {{ normalizedGoogleTagManagerId || 'ID GTM invalido' }}
                  </small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="primary" :disabled="saving || (form.google_tag_manager_id && !normalizedGoogleTagManagerId)">
              <b-spinner v-if="saving" small class="mr-50" />
              Salvar Google Manager
            </b-button>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-card class="mt-2">
      <b-card-title>Gerenciar Conteúdo</b-card-title>
      <b-row>
        <b-col md="6">
          <b-card class="border cursor-pointer" @click="$router.push({ name: 'app-minha-loja-banners' })">
            <div class="d-flex align-items-center">
              <feather-icon icon="ImageIcon" size="32" class="text-primary mr-1" />
              <div>
                <h5 class="mb-0">Banners</h5>
                <small class="text-muted">Gerencie os banners da sua loja</small>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card class="border cursor-pointer" @click="$router.push({ name: 'app-minha-loja-categorias' })">
            <div class="d-flex align-items-center">
              <feather-icon icon="GridIcon" size="32" class="text-primary mr-1" />
              <div>
                <h5 class="mb-0">Categorias</h5>
                <small class="text-muted">Selecione as categorias da sua loja</small>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    </template>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BTabs, BTab, BForm, BFormGroup, BFormInput, BFormTextarea,
  BButton, BRow, BCol, BAlert, BSpinner, BInputGroup, BInputGroupPrepend, BInputGroupAppend,
  BFormFile, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardTitle, BCardText, BTabs, BTab, BForm, BFormGroup, BFormInput, BFormTextarea,
    BButton, BRow, BCol, BAlert, BSpinner, BInputGroup, BInputGroupPrepend, BInputGroupAppend,
    BFormFile, BFormCheckbox,
  },
  data() {
    const maxSizeEnv = Number(process.env.VUE_APP_IMAGE_MAX_SIZE_MB)
    const maxImageSizeMb = Number.isFinite(maxSizeEnv) && maxSizeEnv > 0 ? maxSizeEnv : 5

    return {
      loja: {},
      form: {
        nome_loja: '',
        slug: '',
        descricao: '',
        whatsapp: '',
        instagram: '',
        facebook: '',
        logo_header: '',
        logo_footer: '',
        favicon: '',
        cor_principal: '#F26522',
        cor_secundaria: '#1B3A4B',
        bg_fundo: '#ffffff',
        meta_title: '',
        meta_description: '',
        google_tag_manager_id: '',
        texto_copyright: '',
        empresa_nome: '',
        empresa_info: '',
        email_contato: '',
        telefone_contato: '',
        texto_sobre: '',
        mostrar_powered_by: 1,
      },
      saving: false,
      maxImageSizeMb,
      maxImageSize: maxImageSizeMb * 1024 * 1024,
      maxImageDimension: 1920,
      compressionQuality: 0.92,
      allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
      slugStatus: null,
      slugTimer: null,
      statusMessage: '',
      statusVariant: 'success',
      uploading: { logo_header: false, logo_footer: false, favicon: false },
      temWhiteLabel: null,
      assinatura: null,
      planos: [],
    }
  },
  computed: {
    normalizedGoogleTagManagerId() {
      return this.extractGoogleTagManagerId(this.form.google_tag_manager_id)
    },
  },
  async mounted() {
    await this.verificarAssinatura()
    if (this.temWhiteLabel) {
      await this.carregarLoja()
    }
  },
  methods: {
    validateImageType(file) {
      if (!this.allowedImageTypes.includes(file.type)) {
        this.statusMessage = 'Selecione apenas imagens JPEG, PNG ou GIF.'
        this.statusVariant = 'warning'
        return false
      }

      return true
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)

        image.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(image)
        }

        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Não foi possível ler a imagem selecionada.'))
        }

        image.src = objectUrl
      })
    },
    canvasToFile(canvas, file, mimeType, quality) {
      return new Promise(resolve => {
        canvas.toBlob(blob => {
          if (!blob) {
            resolve(file)
            return
          }

          resolve(new File([blob], file.name, {
            type: mimeType,
            lastModified: file.lastModified,
          }))
        }, mimeType, quality)
      })
    },
    hasTransparency(context, width, height) {
      const { data } = context.getImageData(0, 0, width, height)

      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
          return true
        }
      }

      return false
    },
    async compressImage(file) {
      if (file.type === 'image/gif') {
        return file
      }

      const image = await this.loadImage(file)
      const needsResize = image.width > this.maxImageDimension || image.height > this.maxImageDimension
      const needsCompress = file.size > this.maxImageSize

      if (!needsResize && !needsCompress) {
        return file
      }

      const scale = Math.min(
        this.maxImageDimension / image.width,
        this.maxImageDimension / image.height,
        1,
      )
      const width = Math.max(1, Math.round(image.width * scale))
      const height = Math.max(1, Math.round(image.height * scale))
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, width, height)

      const isPng = file.type === 'image/png'
      const mimeType = isPng && this.hasTransparency(context, width, height)
        ? 'image/png'
        : 'image/jpeg'
      const quality = mimeType === 'image/jpeg' ? this.compressionQuality : undefined

      const compressedFile = await this.canvasToFile(canvas, file, mimeType, quality)

      if (compressedFile.size >= file.size) {
        return file
      }

      return compressedFile
    },
    async prepareImage(file) {
      if (!this.validateImageType(file)) {
        return null
      }

      const compressedFile = await this.compressImage(file)

      if (compressedFile.size > this.maxImageSize) {
        this.statusMessage = `A imagem ainda ficou acima de ${this.maxImageSizeMb}MB após a compressão automática. Reduza a resolução ou envie uma versão menor.`
        this.statusVariant = 'warning'
        return null
      }

      return compressedFile
    },
    async verificarAssinatura() {
      try {
        const { data } = await this.$http.get('/planos/assinaturas/whitelabel-check')
        this.temWhiteLabel = data.tem_acesso
        this.assinatura = data.assinatura || null
      } catch {
        this.temWhiteLabel = false
      }
      try {
        const { data: pl } = await this.$http.get('/planos')
        this.planos = pl.filter(p => p.ativo && p.recursos && p.recursos.whitelabel)
      } catch { this.planos = [] }
    },
    async carregarLoja() {
      try {
        const data = await this.$store.dispatch('minhaLoja/fetchLoja')
        if (data && data.id) {
          this.loja = data
          this.form = {
            nome_loja: data.nome_loja || '',
            slug: data.slug || '',
            descricao: data.descricao || '',
            whatsapp: data.whatsapp || '',
            instagram: data.instagram || '',
            facebook: data.facebook || '',
            logo_header: data.logo_header || '',
            logo_footer: data.logo_footer || '',
            favicon: data.favicon || '',
            cor_principal: data.cor_principal || '#F26522',
            cor_secundaria: data.cor_secundaria || '#1B3A4B',
            bg_fundo: data.bg_fundo || '#ffffff',
            meta_title: data.meta_title || '',
            meta_description: data.meta_description || '',
            google_tag_manager_id: data.google_tag_manager_id || '',
            texto_copyright: data.texto_copyright || '',
            empresa_nome: data.empresa_nome || '',
            empresa_info: data.empresa_info || '',
            email_contato: data.email_contato || '',
            telefone_contato: data.telefone_contato || '',
            texto_sobre: data.texto_sobre || '',
            mostrar_powered_by: data.mostrar_powered_by !== undefined ? data.mostrar_powered_by : 1,
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async salvar() {
      if (!this.form.slug) {
        this.statusMessage = 'O slug é obrigatório.'
        this.statusVariant = 'danger'
        return
      }
      if (!this.form.nome_loja) {
        this.statusMessage = 'O nome da loja é obrigatório.'
        this.statusVariant = 'danger'
        return
      }
      if (this.form.google_tag_manager_id && !this.normalizedGoogleTagManagerId) {
        this.statusMessage = 'Informe um ID valido do Google Tag Manager no formato GTM-XXXXXXX.'
        this.statusVariant = 'danger'
        return
      }
      this.normalizeGoogleTagManagerId()
      this.saving = true
      try {
        const data = await this.$store.dispatch('minhaLoja/saveLoja', this.form)
        this.loja = data
        this.statusMessage = 'Loja salva com sucesso!'
        this.statusVariant = 'success'
      } catch (e) {
        this.statusMessage = e.response?.data?.error || 'Erro ao salvar.'
        this.statusVariant = 'danger'
      } finally {
        this.saving = false
      }
    },
    onSlugInput() {
      clearTimeout(this.slugTimer)
      if (!this.form.slug || this.form.slug.length < 3) {
        this.slugStatus = null
        return
      }
      this.slugStatus = 'checking'
      this.slugTimer = setTimeout(async () => {
        try {
          const result = await this.$store.dispatch('minhaLoja/checkSlug', this.form.slug)
          this.form.slug = result.slug
          this.slugStatus = result.available ? 'available' : 'taken'
        } catch {
          this.slugStatus = null
        }
      }, 500)
    },
    copyLink() {
      const link = `avmarket.com.br/loja/${this.loja.slug}`
      navigator.clipboard.writeText(link)
      this.statusMessage = 'Link copiado!'
      this.statusVariant = 'info'
    },
    async uploadImage(file, field) {
      const selectedFile = Array.isArray(file) ? file[0] : file
      if (!selectedFile) return

      const preparedFile = await this.prepareImage(selectedFile)
      if (!preparedFile) return

      this.uploading[field] = true
      try {
        const url = await this.$store.dispatch('minhaLoja/uploadFile', preparedFile)
        this.form[field] = url
        this.statusMessage = 'Imagem enviada com sucesso!'
        this.statusVariant = 'success'
      } catch (e) {
        this.statusMessage = e.response?.data?.error || 'Erro ao enviar imagem.'
        this.statusVariant = 'danger'
      } finally {
        this.uploading[field] = false
      }
    },
    extractGoogleTagManagerId(value) {
      if (!value || typeof value !== 'string') return ''

      const match = value.match(/GTM-[A-Z0-9]+/i)
      return match ? match[0].toUpperCase() : ''
    },
    normalizeGoogleTagManagerId() {
      this.form.google_tag_manager_id = this.extractGoogleTagManagerId(this.form.google_tag_manager_id)
    },
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  transition: transform 0.2s;
}
.cursor-pointer:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
